import React, { Component } from 'react';
import { QueryRenderer } from '@cubejs-client/react';
import { Modal } from 'antd';
import { cloneDeep, groupBy, reduce } from 'lodash';
import moment from 'moment';

import OtherDetails from './OtherDetails';

import ExportExcel from '../../../components/ExportExcel';
import { ChartCard } from '../../../components/newDesign/ChartCard/ChartCard';
import { DatePickerR } from '../../../components/newDesign/DatePickerR';
import { FilterItem } from '../../../components/newDesign/FilterItem/FilterItem';
import { FilterWrapper } from '../../../components/newDesign/FilterWrapper/FilterWrapper';
import { MainWrapper } from '../../../components/newDesign/MainWrapper/MainWrapper';
import PieTag from '../../../components/newDesign/PieTag/PieTag';
import { RadioGroup } from '../../../components/newDesign/RadioGroup';
import { RowWrapper } from '../../../components/newDesign/RowWrapper/RowWrapper';
import { SelectList } from '../../../components/newDesign/SelectList/SelectList';
import PieChart from '../../../components/visualizations/PieChart';
import VerticalBarChart from '../../../components/visualizations/VerticalBarChart';
import { dateGroups, DAY_IN_MONTH, DAY_IN_WEEK, HOUR_IN_DAY, WEEK_DAYS } from '../../../constants';
import cubejs from '../../../cube';
import { generateBarData, generatePieData } from '../../../utils/visualizations';

const cubejsApi = cubejs({ appId: 1 });

class RegionAnalytics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filtersData: [
        {
          key: 'Appeals.region',
          title: 'Регион',
          options: [],
          placeholder: 'Выберите регион',
        },
        {
          key: 'Appeals.district',
          title: 'Населенный пункт',
          options: [],
          placeholder: 'Выберите населенный пункт',
        },
      ],
      range: [moment().startOf('month').utc(6).startOf('day'), moment().utc(6).endOf('day')],
      pieLegends: [],
      loading: false,
      averageAppeals: 0,
      granularity: 'day',
      radioValue: 'Appeals.region',
      categories: [],
      subCategories: [],
      pieTitle: '',
      tempGroup: null,
      tempGroupLoading: false,
      selectedPie: {
        type: null,
        val: null,
      },
      visible: false,
      filtersDataLocality: {
        'Appeals.region': {
          key: 'Appeals.region',
          title: 'Регион',
          options: [],
          values: [],
        },
        'Appeals.district': {
          key: 'Appeals.district',
          title: 'Населенный пункт',
          options: [],
          values: [],
        },
      },
    };
  }

  async componentDidMount() {
    this.checkForRegion();
    this.loadFilters();
  }

  async loadFilters() {
    let { filtersDataLocality, filtersData, range } = this.state;
    const filterNames = Object.keys(filtersDataLocality);
    let filters = [
      {
        member: 'Appeals.submissionDate',
        operator: 'inDateRange',
        values: range,
      },
    ];
    filterNames.forEach((f) => {
      const filter = filtersDataLocality[f];
      if (filter.values.length) {
        filters = [
          ...filters,
          {
            member: f,
            operator: 'equals',
            values: filter.values.map((f) => f.toString()),
          },
        ];
      }
    });
    const reqs = filtersData.map((f) => cubejsApi.load({ dimensions: [f.key], filters }));
    const responses = await Promise.all(reqs);
    responses.forEach((res, i) => {
      filtersData[i].options = res.rawData().map((e) => e[filtersData[i].key]);
    });
    const filtersReq = filterNames.map((f) => cubejsApi.load({ dimensions: [f] }));
    const filterResponses = await Promise.all(filtersReq);

    filterResponses.forEach((res, i) => {
      filtersDataLocality = {
        ...filtersDataLocality,
        [filterNames[i]]: {
          ...filtersDataLocality[filterNames[i]],
          options: res
            .rawData()
            .map((d) => d[filterNames[i]])
            .filter((e) => e),
        },
      };
    });
    this.setState({ filtersDataLocality, filtersData });
  }

  checkForRegion = () => {
    let { filtersDataLocality } = this.state;
    let role = JSON.parse(localStorage.getItem('user_params'));
    if (role.roles[0]?.region?.length) {
      let regions = role.roles[0].region
        .filter((region) => !region?.parentId)
        .map((e) => e.regionName);
      if (regions.length !== 0) {
        filtersDataLocality['Appeals.region'].options = regions;
        filtersDataLocality['Appeals.region'].values = regions;
        filtersDataLocality['Appeals.district'].options = regions;
        this.setState({ filtersDataLocality });
      }
    }
  };

  applyFilters = (filter, values) => {
    let { filtersDataLocality } = this.state;
    this.setState({
      filtersDataLocality: {
        ...filtersDataLocality,
        [filter]: {
          ...filtersDataLocality[filter],
          values,
        },
      },
    });
  };

  changeRange = (value) => {
    if (value === DAY_IN_MONTH || value === DAY_IN_WEEK)
      this.setState({
        granularity: 'day',
        tempGroup: value,
        tempGroupLoading: true,
      });
    else if (value === HOUR_IN_DAY)
      this.setState({
        granularity: 'hour',
        tempGroup: value,
        tempGroupLoading: true,
      });
    else
      this.setState({
        granularity: value,
        tempGroup: null,
        tempGroupLoading: true,
      });

    setTimeout(() => {
      this.setState({
        tempGroupLoading: false,
      });
    }, 1000);
  };

  resetSelectedPie = () => {
    this.setState({
      selectedPie: { type: null, val: null },
      pieLegends: [],
    });
  };

  handlePieClick = (val, type) => {
    const { range } = this.state;
    let filters = [
      {
        member: 'Appeals.submissionDate',
        operator: 'inDateRange',
        values: range,
      },
    ];
    if (val === 'Другие') {
      let query = { measures: ['Appeals.appealsNum'], filters };
      query.dimensions = [type];
      this.setState({ selectedPie: { type, val }, visible: true });
      this.setPieData(query, type, 'other');
    } else {
      const dim = type === 'Appeals.region' ? 'Appeals.district' : 'Appeals.region';
      let query = {
        dimensions: [dim],
        measures: ['Appeals.appealsNum'],
        filters: [
          ...filters,
          {
            dimension: type,
            operator: 'contains',
            values: [val],
          },
        ],
      };
      this.setState({ selectedPie: { type, val } });
      this.setPieData(query, dim);
    }
  };

  setPieData = (query, type, other) => {
    cubejsApi.load(query).then((r) => {
      let data = r.rawData().map((e) => ({ title: e[type], value: +e['Appeals.appealsNum'] }));
      const total = data.reduce((a, b) => a + b.value, 0);
      data = data.map((e, i) => ({
        ...e,
        percent: ((e.value * 100) / total).toFixed(2),
      }));
      if (other) {
        this.setState({
          pieLegends: data.filter((e) => +e.percent < 1),
        });
      } else {
        this.setState({ pieLegends: data });
      }
    });
  };

  radioChange = (evt) => {
    this.setState({
      radioValue: evt.target.value,
    });
  };

  changeFilters = (val, key) => {
    if (key === 'Appeals.region') {
      this.setState({ categories: val });
    } else {
      this.setState({ subCategories: val });
    }
  };

  calcPercent = (data) => {
    if (data) {
      let summary = 0;
      const noOtherData = data.filter((it) => !it.sliceGrouperOther);
      noOtherData.forEach((d) => {
        summary = summary + parseFloat(d['Appeals.appealsNum']);
      });
      return noOtherData.map((i) => ({
        ...i,
        percent: ((i['Appeals.appealsNum'] * 100) / summary).toFixed(2),
      }));
    }
  };
  getGroupedTemp = (barData = {}) => {
    let { tempGroup } = this.state;
    let newData = [],
      { data = [], ...others } = barData;
    if (tempGroup) {
      const groupedDays = groupBy(data, (el) => {
        if (tempGroup === DAY_IN_MONTH)
          return moment(el['Appeals.submissionDate'], 'YYYY/MM/DD').format('D');
        else if (tempGroup === DAY_IN_WEEK)
          return moment(el['Appeals.submissionDate'], 'YYYY/MM/DD').isoWeekday();
        else if (tempGroup === HOUR_IN_DAY)
          return parseInt(moment(el['Appeals.submissionDate']).format('HH'));
      });
      Object.keys(groupedDays).forEach((key) => {
        newData.push({
          'Appeals.submissionDate':
            tempGroup === DAY_IN_WEEK
              ? WEEK_DAYS[key - 1]
              : tempGroup === HOUR_IN_DAY
              ? key + ':00'
              : key,
          'Appeals.appealsNum': reduce(
            groupedDays[key],
            function (sum, n) {
              return sum + parseFloat(n['Appeals.appealsNum']);
            },
            0
          ),
        });
      });
      return { data: newData, ...others };
    } else return { data, ...others };
  };

  hideDetails = () => {
    this.setState({
      visible: false,
      selectedPie: { type: null, val: null },
      pieLegends: [],
    });
  };

  render() {
    const {
      range,
      granularity,
      filtersData,
      radioValue,
      categories,
      subCategories,
      filtersDataLocality,
      tempGroup,
      tempGroupLoading,
      loading,
      selectedPie,
      pieLegends,
      visible,
    } = this.state;
    const filterNames = Object.keys(filtersDataLocality);
    let filters = [
      {
        member: 'Appeals.submissionDate',
        operator: 'inDateRange',
        values: range,
      },
    ];
    filterNames.forEach((f) => {
      const filter = filtersDataLocality[f];
      if (filter.values.length) {
        filters = [
          ...filters,
          {
            member: f,
            operator: 'equals',
            values: filter.values.map((f) => f.toString()),
          },
        ];
      }
    });

    return (
      <MainWrapper>
        <FilterWrapper>
          <FilterItem>
            <DatePickerR
              label={'Период:'}
              onChange={(range) => {
                this.setState({ range }, () => {
                  this.loadFilters();
                });
              }}
              showTime={{
                secondStep: 60,
                minuteStep: 15,
              }}
              allowClear={false}
              value={range}
              size="small"
              separator="—"
            />
          </FilterItem>
        </FilterWrapper>

        <RowWrapper>
          <ChartCard title="Регион">
            {selectedPie?.type === 'Appeals.region' && (
              <PieTag
                onClose={this.resetSelectedPie}
                title={'Выбранный регион: ' + selectedPie.val}
              />
            )}
            <QueryRenderer
              query={{
                measures: ['Appeals.appealsNum'],
                dimensions: ['Appeals.region'],
                filters,
              }}
              cubejsApi={cubejsApi}
              render={({ resultSet }) => {
                if (!resultSet) return null;
                const { data, nameKey, dataKey } = generatePieData(resultSet);

                return (
                  <>
                    <PieChart
                      loading={loading}
                      hideSmallValues
                      id="piechartid1"
                      legendCopyable
                      disableMovement
                      showTotal
                      data={selectedPie.type === 'Appeals.district' ? pieLegends : data}
                      nameKey={selectedPie.type === 'Appeals.district' ? 'title' : nameKey}
                      dataKey={selectedPie.type === 'Appeals.district' ? 'value' : dataKey}
                      handleClick={(evt) => this.handlePieClick(evt, 'Appeals.region')}
                      height="450px"
                    />
                    <ExportExcel
                      filename="Регионы"
                      data={this.calcPercent(generatePieData(resultSet)?.data)}
                      style={{ position: 'absolute', top: 10, right: 10 }}
                      fields={[
                        { title: 'Регион', dataIndex: 'Appeals.region' },

                        {
                          title: 'Количество',
                          dataIndex: 'Appeals.appealsNum',
                        },
                        {
                          title: 'Процент',
                          dataIndex: 'percent',
                        },
                      ]}
                    />
                  </>
                );
              }}
            />
          </ChartCard>
          <ChartCard title="Населенный пункт">
            {selectedPie?.type === 'Appeals.district' && (
              <PieTag
                onClose={this.resetSelectedPie}
                title={'Выбранный населенный пункт: ' + selectedPie.val}
              />
            )}
            <QueryRenderer
              query={{
                measures: ['Appeals.appealsNum'],
                dimensions: ['Appeals.district'],
                filters,
              }}
              cubejsApi={cubejsApi}
              render={({ resultSet }) => {
                if (!resultSet) return null;
                const { data, nameKey, dataKey } = generatePieData(resultSet);
                return (
                  <>
                    <PieChart
                      loading={loading}
                      id="piechartid2"
                      showTotal
                      hideSmallValues
                      legendCopyable
                      disableMovement
                      handleClick={(evt) => this.handlePieClick(evt, 'Appeals.district')}
                      data={selectedPie.type === 'Appeals.region' ? pieLegends : data}
                      nameKey={selectedPie.type === 'Appeals.region' ? 'title' : nameKey}
                      dataKey={selectedPie.type === 'Appeals.region' ? 'value' : dataKey}
                      height="450px"
                    />
                    <ExportExcel
                      filename="Населенные пункты"
                      data={this.calcPercent(generatePieData(resultSet)?.data)}
                      style={{ position: 'absolute', top: 10, right: 10 }}
                      fields={[
                        {
                          title: 'Населенный пункт',
                          dataIndex: 'Appeals.district',
                        },

                        {
                          title: 'Количество',
                          dataIndex: 'Appeals.appealsNum',
                        },
                        {
                          title: 'Процент',
                          dataIndex: 'percent',
                        },
                      ]}
                    />
                  </>
                );
              }}
            />
          </ChartCard>
        </RowWrapper>

        <h2 style={{ marginTop: '30px', textAlign: 'left' }}>
          Количество обращений в разрезе периода
        </h2>
        <RadioGroup
          onChange={this.radioChange}
          value={radioValue}
          list={[
            {
              key: 'Appeals.region',
              value: 'Регион',
            },
            {
              key: 'Appeals.district',
              value: 'Населенный пункт',
            },
          ]}
        />
        <div style={{ minHeight: '50vh' }}>
          <FilterWrapper>
            <FilterItem>
              <SelectList
                label={'Шаблон:'}
                onChange={(value) => this.changeRange(value)}
                defaultValue={granularity}
                size="small"
                showKey="label"
                valueKey="granularity"
                list={dateGroups}
              />
            </FilterItem>
            {filtersData.map((el) => {
              return (
                el.key === radioValue && (
                  <FilterItem>
                    <SelectList
                      label={el.placeholder + ':'}
                      onChange={(val) => this.changeFilters(val, el.key)}
                      mode="multiple"
                      value={el.key === 'Appeals.region' ? categories : subCategories}
                      size="small"
                      list={el.options.concat('Все')}
                    />
                  </FilterItem>
                )
              );
            })}
          </FilterWrapper>
          <RowWrapper>
            {radioValue === 'Appeals.region' &&
              categories.map((cat) => (
                <ChartCard title={cat} key={cat}>
                  <QueryRenderer
                    query={{
                      measures: ['Appeals.appealsNum'],
                      timeDimensions: [
                        {
                          dimension: 'Appeals.submissionDate',
                          granularity: granularity,
                        },
                      ],
                      filters: [
                        ...filters,
                        {
                          dimension: 'Appeals.region',
                          operator: cat !== 'Все' ? 'equals' : 'notEquals',
                          values: [cat],
                        },
                      ],
                    }}
                    cubejsApi={cubejsApi}
                    render={({ resultSet, loadingState }) => {
                      return (
                        <VerticalBarChart
                          loading={loadingState?.isLoading || tempGroupLoading}
                          showLegend={false}
                          id={`VerticalBarChart${cat}`}
                          dateAxis={!tempGroup}
                          height="450px"
                          {...this.getGroupedTemp(cloneDeep(generateBarData(resultSet)))}
                          values={[
                            {
                              title: 'Количество обращений',
                              key: 'Appeals.appealsNum',
                            },
                          ]}
                          rotate
                        />
                      );
                    }}
                  />
                </ChartCard>
              ))}
            {radioValue === 'Appeals.district' &&
              subCategories.map((cat) => (
                <ChartCard title={cat} key={cat}>
                  <QueryRenderer
                    query={{
                      measures: ['Appeals.appealsNum'],
                      timeDimensions: [
                        {
                          dimension: 'Appeals.submissionDate',
                          granularity: granularity,
                        },
                      ],
                      filters: [
                        ...filters,
                        {
                          dimension: 'Appeals.district',
                          operator: cat !== 'Все' ? 'equals' : 'notEquals',
                          values: [cat],
                        },
                      ],
                    }}
                    cubejsApi={cubejsApi}
                    render={({ resultSet, loadingState }) => {
                      return (
                        <VerticalBarChart
                          loading={loadingState?.isLoading || tempGroupLoading}
                          id={`VerticalBarChart${cat}`}
                          dateAxis={!tempGroup}
                          height="450px"
                          {...this.getGroupedTemp(cloneDeep(generateBarData(resultSet)))}
                          values={[
                            {
                              title: 'Количество обращений',
                              key: 'Appeals.appealsNum',
                            },
                          ]}
                          rotate
                        />
                      );
                    }}
                  />
                </ChartCard>
              ))}
          </RowWrapper>
        </div>
        <Modal
          title={
            selectedPie.type === 'Appeals.region' ? 'Другие регионы' : 'Другие населенные пункты'
          }
          visible={visible}
          onCancel={this.hideDetails}
          width={800}
          footer={false}
          centered
          destroyOnClose
        >
          <OtherDetails data={pieLegends} type={selectedPie.type} />
        </Modal>
      </MainWrapper>
    );
  }
}

export default RegionAnalytics;
